import ActionTypes from "../inc/ActionsTypes";
import Helper from "../inc/Helper";
import Settings from "../inc/Settings";

const DefaultState = {
    user:null,
    isLogin:false,
    isLoading:true
}
const AuthReducer = (state = DefaultState, actions) =>{
    if(actions.type ===  ActionTypes.SET_LOGIN ){
        state = {
            ...state,
            isLogin:true,
            user:actions.payload,
        }
    }
    if(actions.type ===  ActionTypes.SET_LOGOUT ){
        state = {
            ...state,
            isLogin:false,
            user:null,
        }
        Helper.removeCookie(Settings.userTokenKey);
    }
    if(actions.type ===  ActionTypes.SET_USER ){
        state = {
            ...state,
            isLogin:true,
            user:actions.payload
        }
    }
    if(actions.type ===  ActionTypes.RESET_USER ){
        state = {
            ...state,
            user:null
        }
    }
    if(actions.type ===  ActionTypes.SET_AUTH_LOADING ){
        state = {
            ...state,
            isLoading: actions.payload
        }
    }
    if(actions.type===ActionTypes.SET_USER_IMAGE){
        return {
            ...state,
            user: {
                ...state.user,
                Image: actions.payload,
            },
        };
    }
    return state;
}
export default AuthReducer;